import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

export const parseLocalDateTime = (
  timestamp: string | Dayjs,
  timeZone: string
): Dayjs => {
  const calendarTime = dayjs.utc(timestamp).format("YYYY-MM-DDTHH:mm:ss.SSS");
  const offset = dayjs.tz(calendarTime, timeZone).format("Z");
  // Explicit offsets prevent browser DST from changing the parsed instant.
  return dayjs.utc(`${calendarTime}${offset}`);
};
